import { render, staticRenderFns } from "./useRouter.vue?vue&type=template&id=e44416ba&scoped=true&"
import script from "./useRouter.vue?vue&type=script&lang=js&"
export * from "./useRouter.vue?vue&type=script&lang=js&"
import style0 from "./useRouter.vue?vue&type=style&index=0&id=e44416ba&lang=scss&scoped=true&"
import style1 from "./useRouter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44416ba",
  null
  
)

export default component.exports